import * as types from "../constants/ActionTypes";

const activeheader = (state = [], action) => {
  switch (action.type) {
    case types.CHANGE_ACTIVEHEADER:
      const newState = [...state];
      const verificar = newState.find(
        (value) => value.label === action.contactid
      );

      if (verificar) {
        verificar.active = action.status;
        return newState;
      } else {
        let novoObj = { label: action.contactid, active: action.status };
        return [...newState, novoObj];
      }

    default:
      return state;
  }
};

export default activeheader;
